import React, { useEffect, useState } from 'react';
import { ProgressBar, ProgressWrapper, Value } from './LineupProgressStyles';
import LineupManager from 'models/setLineup/LineupManager';
import { observer } from 'mobx-react-lite';
import { htmlPrefilter } from 'cypress/types/jquery';
interface IProps {
  homeTeamManager?: LineupManager;
  awayTeamManager?: LineupManager;
  requiredPositionsCount?: number;
}
const LineupProgress: React.FC<IProps> = observer((props) => {
  const { homeTeamManager, awayTeamManager, requiredPositionsCount } = props;
  const [progress, setProgress] = useState<string | number>(0);

  useEffect(() => {
    setProgress(() => {
      let positions = 0;

      positions += homeTeamManager?.lineup.length || requiredPositionsCount || 0;
      positions += awayTeamManager?.lineup.length || requiredPositionsCount || 0;

      const home = new Set(
        homeTeamManager?.lineup
          .filter((player) => player.position !== 'DH' && player.position !== undefined && player.player !== undefined)
          .map((player) => player.position)
      );
      const homeDHFilled = homeTeamManager?.lineup.filter((player) => player.position === 'DH' && player.player !== undefined).length || 0;

      const away = new Set(
        awayTeamManager?.lineup
          .filter((player) => player.position !== 'DH' && player.position !== undefined && player.player !== undefined)
          .map((player) => player.position)
      );
      const awayDHFilled = awayTeamManager?.lineup.filter((player) => player.position === 'DH' && player.player !== undefined).length || 0;

      const selectedPositions = home.size + homeDHFilled + away.size + awayDHFilled;

      let result = 0;

      for (let i = 0; i < selectedPositions; i++) {
        if (positions > 0) {
          result += Number(100 / positions);
        }
      }

      return result.toFixed(0);
    });
  }, [homeTeamManager?.hasEntryChanged, awayTeamManager?.hasEntryChanged]);

  return (
    <ProgressWrapper>
      <Value>{progress}%</Value>
      <ProgressBar leftOffset={`${progress}`} />
    </ProgressWrapper>
  );
});

LineupProgress.displayName = 'LineupProgress';

export default LineupProgress;
